module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAKklEQVR4AWNYsGDxTHLx+49fG+iJ323aNonaeBSP4lE8ikfxKAbVMfTGAFQXhT3Bv/eTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_steptracker+maincontainer.png
// module id = 357
// module chunks = 0